import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Popover, TextButton } from 'seagull';
import { PlusCircle } from 'seagull/icons';
import { useActiveServiceTemplates } from '~/hooks/reactQuery/queries/useActiveServiceTemplates';
import { useLocaleKeys } from '~/i18n';
import { AddServicesPopover } from './AddServicesPopover/AddServicesPopover';
export function AddServicesButton(props) {
    const { t: addTexts } = useLocaleKeys('components.addServicesButton');
    const { className, agreementData, disabled, testId = '', text = addTexts.addServices(), variant = 'button', popoverHorizontalAlign = 'center', onClick, onServicesAdded } = props;
    useActiveServiceTemplates({
        refreshOnMount: true
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = !!anchorEl;
    function addServices(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    function renderButton() {
        switch(variant){
            case 'button':
                return /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'select_services'
                    },
                    type: "button",
                    disabled: disabled,
                    testId: testId,
                    className: className,
                    onClick: addServices,
                    children: text
                });
            case 'textWithIcon':
                return /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'select_services'
                    },
                    type: "button",
                    className: className,
                    disabled: disabled,
                    underline: "none",
                    weight: "normal",
                    testId: testId,
                    prefixIcon: /*#__PURE__*/ _jsx(PlusCircle, {}),
                    onClick: addServices,
                    children: text
                });
        }
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            renderButton(),
            /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorEl,
                open: isOpen,
                anchorOrigin: {
                    vertical: -8,
                    horizontal: popoverHorizontalAlign
                },
                transformOrigin: {
                    vertical: 'bottom',
                    horizontal: popoverHorizontalAlign
                },
                onClose: handleClose,
                children: /*#__PURE__*/ _jsx(AddServicesPopover, {
                    testId: testId,
                    agreementData: agreementData,
                    onClose: handleClose,
                    onSelectServiceTemplate: (service)=>{
                        handleClose();
                        onServicesAdded([
                            service
                        ]);
                    }
                })
            })
        ]
    });
}
